import React from "react";

/**
 * Pure-render condensed view of a seller intelligence doc — top persona + N
 * others, top competitor + N others, top disqualifier, category pitch.
 *
 * Used in:
 *  - Settings Seller Profiles listing page (per-card preview of derived intel)
 *  - Edit page panel (default condensed view, expand for full detail)
 *
 * Accepts `intel` (the intelligence map returned by GET /sellerIntelligence/{id})
 * or null. Renders nothing when null OR empty.
 */
const SellerIntelSummary = ({ intel, variant = "card" }) => {
  if (!intel || typeof intel !== "object") return null;
  const personas = Array.isArray(intel.canonical_buyer_personas) ? intel.canonical_buyer_personas : [];
  const directComp = Array.isArray(intel.competitor_map?.direct) ? intel.competitor_map.direct : [];
  const disqs = Array.isArray(intel.account_disqualifiers) ? intel.account_disqualifiers : [];

  if (personas.length === 0 && directComp.length === 0 && disqs.length === 0 && !intel.category_pitch_one_liner) {
    return null;
  }

  const topPersona = personas[0];
  const personaOthers = Math.max(personas.length - 1, 0);
  const topCompetitor = directComp[0];
  const competitorOthers = Math.max(directComp.length - 1, 0);
  const topDisqualifier = disqs[0];

  return (
    <div className={`siSum siSum--${variant}`}>
      {intel.category_pitch_one_liner && variant === "card" && (
        <p className="siSum__pitch">{intel.category_pitch_one_liner}</p>
      )}

      {topPersona && (
        <div className="siSum__row">
          <span className="siSum__label">🎯 Target:</span>
          <span className="siSum__value">
            <strong>{topPersona.title}</strong>
            {personaOthers > 0 && <span className="siSum__more"> + {personaOthers} other{personaOthers === 1 ? "" : "s"}</span>}
          </span>
        </div>
      )}

      {topCompetitor && (
        <div className="siSum__row">
          <span className="siSum__label">⚔️ Competitor:</span>
          <span className="siSum__value">
            <strong>{topCompetitor}</strong>
            {competitorOthers > 0 && <span className="siSum__more"> + {competitorOthers} other{competitorOthers === 1 ? "" : "s"}</span>}
          </span>
        </div>
      )}

      {topDisqualifier && variant === "card" && (
        <div className="siSum__row">
          <span className="siSum__label">🛑 Skip if:</span>
          <span className="siSum__value">{topDisqualifier}</span>
        </div>
      )}
    </div>
  );
};

export default SellerIntelSummary;
